import type { ButtonAlign } from '@/types'
import { useWindowSize } from '@vueuse/core'
import { computed } from 'vue'

import variables from '@/assets/variables.json'

const { md } = variables
const BUTTON_ALIGN_BREAKPOINT = Number(md.replace('px', ''))

/**
 * The `useButtonAlign` function calculates the alignment of a button based on the window width.
 * @returns {
 *   align
 * }
 */
export const useButtonAlign = () => {
  const { width } = useWindowSize()

  const align = computed<ButtonAlign>(() =>
    width.value > BUTTON_ALIGN_BREAKPOINT ? 'end' : 'center'
  )

  return {
    align
  }
}
